<template>
  <div>
    <PublicLayout>
      <header
        class="header text-dark"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/products/product_header_2023.png')})`,
        }"
      >
        <div class="container">
          <h1>Thông tin sản phẩm<!--產品資訊--></h1>
        </div>
      </header>
      <HeaderNav />
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec mb-0">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              Tạo ra các sản phẩm axit nucleic chắc chắn và an toàn với chất lượng cao
              <!--以高品質打造安心、安全的核酸製品-->
            </h2>
            <p>
              Là công ty tiên phong trong lĩnh vực dinh dưỡng axit nucleic, Fudezhi đã sản xuất với tiêu chuẩn cao trên thiết bị sản xuất mới nhất nhằm 
              cung cấp các sản phẩm axit nucleic chất lượng cao cho người tiêu dùng. Trong những năm gần đây, với sự chú ý ngày càng tăng đến axit nucleic, 
              chúng tôi sẽ tiếp tục cố gắng cung cấp các sản phẩm chất lượng cao đồng thời phát triển các sản phẩm mới.
              <!--富地滋作為核酸營養的先驅企業，為了提供高品質的核酸製品給消費者，一直在最新的生產設備上以高標準的要求來進行生產。近年來，隨著對核酸的日益關注，我們將繼續努力提供高品質的製品，同時致力於新製品的開發。-->
            </p>
            <div class="row justify-content-center">
              <div class="col-sm-10 col-md-10">
                <div class="light-border-box text-center">
                  <h2 class="section-title mb-0">
                    Bổ sung dinh dưỡng axit nucleic bên trong và bên ngoài cơ thể để duy trì sức khỏe và sắc đẹp
                    <!--體內體外攝取核酸營養，維持健康與美麗-->
                  </h2>
                  <p class="text-info mt-3">
                    Ý tưởng đằng sau sản phẩm bổ sung dinh dưỡng bên trong và bên ngoài của Fudizi
                    <!--富地滋 內在+外在 營養補給的發想-->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- product-toggles-section -->
        <!-- https://fordays.jp/products/ -->
        <section class="product-togglers-section">
          <div class="container">
            <h2 class="section-title text-center">
              Dự án sản phẩm Fudizi
              <!--富地滋產品項目-->
            </h2>
            <div class="product-togglers">
              <div class="product-toggler">
                <div
                  class="product-toggler-content"
                  v-scroll-to="'#productNormalSec'"
                >
                  <img
                    :src="
                      require('@/assets/public/images/product-toggler/nav_img_supplement_2023.png')
                    "
                    alt=""
                  />
                  <h4>bổ sung dinh dưỡng<!--營養補助食品--></h4>
                </div>
              </div>
              <div class="product-toggler" v-scroll-to="'#productMousaSec'">
                <div class="product-toggler-content">
                  <img
                    :src="
                      require('@/assets/public/images/product-toggler/nav_img_cosmetics_2023.png')
                    "
                    alt=""
                  />
                  <h4>Sản phẩm chăm sóc da<!--保養品--></h4>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- product-toggles-section -->
        <section id="productNormalSec" class="product-mousa-sec">
          <div class="container">
            <h2 class="section-title section-mousa-title">bổ sung dinh dưỡng<!--營養補助食品--></h2>
            <p></p>
            <div class="row mt-4">
              <ProductListItem
                v-for="product in normalProductList"
                :key="product.id"
                :id="product.id"
                :image="product.image"
                :name="product.name"
                :subtitle="product.subtitle"
                :description="product.description"
                :imageLarge="product.imageLarge"
              />
            </div>
          </div>
        </section>
        <section id="productCareSec" class="product-mousa-sec">
          <div class="container">
            <h2 class="section-title section-mousa-title">
              Dòng sản phẩm chăm sóc hàng đầu của Mengsha LU<!--夢莎LU頂級保養系列-->
            </h2>
            <p>
              Vẻ đẹp thức tỉnh! <strong>Chứa thành phần axit nucleic</strong>, Dòng sản phẩm chăm sóc da hàng đầu tạo nên làn da đẹp quyến rũ
              <!--美力覺醒！<strong>含有核酸成分</strong>，打造魅惑迷人美肌的頂級保養系列-->
            </p>
            <div class="row mt-4">
              <ProductListItem
                v-for="product in careProductList"
                :key="product.id"
                :id="product.id"
                :image="product.image"
                :name="product.name"
                :subtitle="product.subtitle"
                :description="product.description"
                :imageLarge="product.imageLarge"
              />
            </div>
          </div>
        </section>
        <!-- product-toggles-section -->
        <MousaProductSection />
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "@/components/public/PublicLayout";
import HeaderNav from "@/components/public/headerNav/productHeaderNav";
import ProductListItem from "@/components/public/ProductListItem";
import MousaProductSection from "@/components/public/MousaProductSection";
export default {
  name: "ProductsScreen",
  components: {
    PublicLayout,
    HeaderNav,
    ProductListItem,
    MousaProductSection,
  },
  data() {
    return {
      normalProductList: [
        {
          id: "1",
          name: "Collagen Fudizhi DN",
          subtitle: "Nước uống giải khát",
          description:
            'Thăng hoa thành vật liệu axit nucleic độc quyền và độc quyền “coreF-Revo.1"',
          image: require("@/assets/public/images/products/drink_2021-thumb-510x510-1577.png"),
          imageLarge: true,
        },
        {
          id: "2",
          name: "Túi xách tay Fortune Zi LOHAS",
          subtitle: "Thực phẩm bổ sung axit amin (dạng hạt)",
          description: "Duy trì sức mạnh cơ bắp và duy trì sự cân bằng cơ thể",
          image: require("@/assets/public/images/products/BCAA_newpkg-thumb-510x510-1421_04.png"),
          imageLarge: true,
        },
        {
          id: "11",
          name: "Nước uống Collagen Mengsha ED mới EX",
          subtitle: "Nước uống giải khát",
          description:
            "Chứa chiết xuất dứa mới được nâng cấp, collagen tripeptide, vitamin C, khoáng chất và chiết xuất vỏ móng mèo mới được bổ sung và các thành phần khác trong sự kết hợp cân bằng để duy trì sức khỏe và sắc đẹp mỗi ngày.",
          image: require("@/assets/public/images/products/IMG_058-thumb-510x363-1106_2023.png"),
          imageLarge: true,
        },
      ],
      careProductList: [
        {
          id: "4",
          name: "Tinh chất làm đẹp hiệu suất cao LU tia",
          subtitle: "Nước hoa",
          description:
            "Một chai có nhiều lợi ích bảo trì. Chăm sóc chống lão hóa chăm sóc da cẩn thận mang lại cho làn da cảm giác chưa từng có trước đây.",
          image: require("@/assets/public/images/products/LU_tia高機能美容精華液.png"),
          imageLarge: true,
        },
      ],
    };
  },
};
</script>
